module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('img', {
    staticClass: "weui-vcode-img",
    attrs: {
      "src": _vm.img
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-aff98d9e!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/addon-img.vue
// module id = 281
// module chunks = 0